import { useEffect } from 'react';
import { GameEvent, GameState } from '../../types/game';
import { GameAction } from '../gameReducer';

interface UseEventTrimmingParams {
  gameState: GameState;
  dispatch: React.Dispatch<GameAction>;
  maxEvents?: number;
}

// Keep a small buffer. iOS WKWebView has restricted JIT and limited JS heap;
// large event arrays cause O(n) spread costs on every dispatch that compound
// over the course of a game. 200 is enough for all UI features (history shows
// last 20, stats are maintained incrementally on player.statistics).
const DEFAULT_MAX_EVENTS = 200;
const CRITICAL_TYPES = new Set<GameEvent['type']>(['ORDER_FINALIZED', 'ADD_PLAYER']);

export function useEventTrimming({ gameState, dispatch, maxEvents = DEFAULT_MAX_EVENTS }: UseEventTrimmingParams) {
  useEffect(() => {
    const events = gameState.events || [];
    if (events.length <= maxEvents) return;
    const keepRecent = Math.floor(maxEvents * 0.8);
    const recent = events.slice(-keepRecent);
    const critical = events
      .slice(0, -keepRecent)
      .filter(event => CRITICAL_TYPES.has(event.type));
    dispatch({ type: 'TRIM_EVENTS', events: [...critical, ...recent] });
  }, [dispatch, gameState.events, maxEvents]);
}

